Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReviewContentParser
  parse: (reviewJson) ->
    author = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessAuthorParser()
      .parse(reviewJson.author)

    review = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReviewParser()
      .parse(reviewJson)

    locationSummary = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessLocationSummaryParser()
      .parse(reviewJson.location)

    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewContent(author, review, locationSummary)
